"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.VALIDATE_ADDRESS = void 0;
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _templateObject;
var VALIDATE_ADDRESS = (0, _graphqlTag["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2["default"])(["\n  query getValidAddress($requestOptions: String!, $market: String, $lang: String, $path:String) {\n    getValidAddress(requestOptions: $requestOptions, market: $market, lang: $lang, path: $path) {\n      address\n      zipCode\n     \tisValidAddress\n    }\n  }\n"])));
exports.VALIDATE_ADDRESS = VALIDATE_ADDRESS;